export default __webpack_public_path__ + "static/media/vscode.5a3beac9.svg";